import {
  collection,
  getDocs,
  addDoc,
  updateDoc,
  doc,
  orderBy,
  limit,
  serverTimestamp,
} from 'firebase/firestore';
import { db } from '../../../firebase';
import { tenantQuery } from '../../../utils/firestoreHelpers';
import { where } from 'firebase/firestore';

// ── Stok hareketi kaydet ─────────────────────────────────────────────────────
export async function addStockMovement({ businessId, serviceId, serviceName, type, qty, note = '', createdBy = '' }) {
  await addDoc(collection(db, 'stock_movements'), {
    businessId,
    serviceId,
    serviceName,
    type,           // 'in' | 'out' | 'adjustment'
    qty: Number(qty),
    note,
    createdBy,
    createdAt: serverTimestamp(),
  });
}

// ── Ürünün stok miktarını güncelle ──────────────────────────────────────────
export async function updateProductStock(serviceId, newQty) {
  await updateDoc(doc(db, 'services', serviceId), {
    stockQty: Number(newQty),
  });
}

// ── Stok hareketi kaydet + ürün stokunu güncelle (atomik değil, best-effort) ─
export async function applyStockMovement({ businessId, serviceId, serviceName, currentQty, type, qty, note, createdBy }) {
  const delta = type === 'out' ? -Math.abs(qty) : Math.abs(qty);
  const newQty = Math.max(0, currentQty + delta);
  await Promise.all([
    addStockMovement({ businessId, serviceId, serviceName, type, qty: Math.abs(qty), note, createdBy }),
    updateProductStock(serviceId, newQty),
  ]);
  return newQty;
}

// ── Bir ürünün son hareketlerini getir ───────────────────────────────────────
export async function fetchStockMovements(businessId, serviceId, limitCount = 20) {
  const snap = await getDocs(
    tenantQuery(
      collection(db, 'stock_movements'),
      businessId,
      where('serviceId', '==', serviceId),
      orderBy('createdAt', 'desc'),
      limit(limitCount),
    ),
  );
  return snap.docs.map(d => ({ id: d.id, ...d.data() }));
}

// ── Tüm ürünlerin stok hareketlerini getir (rapor için) ─────────────────────
export async function fetchAllStockMovements(businessId, limitCount = 100) {
  const snap = await getDocs(
    tenantQuery(
      collection(db, 'stock_movements'),
      businessId,
      orderBy('createdAt', 'desc'),
      limit(limitCount),
    ),
  );
  return snap.docs.map(d => ({ id: d.id, ...d.data() }));
}
